import { render, staticRenderFns } from "./ToeflPrimaryStep2TimeManagerComponent.vue?vue&type=template&id=c16aa74e&"
import script from "./ToeflPrimaryStep2TimeManagerComponent.vue?vue&type=script&lang=js&"
export * from "./ToeflPrimaryStep2TimeManagerComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports